import type { PropsWithChildren } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import styled from 'styled-components';

import { SBHorizontal, Vertical } from '#src/atoms/layout/flex/index.tsx';
import { LabelL } from '#src/atoms/typography/index.tsx';
import { fantasy } from '#src/lib/glossary.ts';

import { ScoreGaugeTargetBar } from './ScoreGaugeTargeBar/index.tsx';

const Root = styled(Vertical).attrs({ gap: 1.5 })`
  border-radius: var(--double-unit);
  padding: var(--double-unit);
  background-color: var(--c-nd-50);
  backdrop-filter: blur(32px);
`;

type TProps = {
  name: any;
  currentScore: number;
  sections: { score: number | null }[];
  cursorPosition: string;
};

export const ScoreGaugeTarget = ({
  name,
  currentScore,
  sections,
  cursorPosition,
  children,
}: PropsWithChildren<TProps>) => {
  return (
    <Root>
      <SBHorizontal>
        {name}
        <LabelL bold>
          <FormattedMessage
            {...fantasy.pointsWithoutFormat}
            values={{
              score: (
                <FormattedNumber
                  value={currentScore}
                  maximumFractionDigits={2}
                />
              ),
            }}
          />
        </LabelL>
      </SBHorizontal>
      <ScoreGaugeTargetBar
        currentScore={currentScore}
        sections={sections}
        cursorPosition={cursorPosition}
      />
      {children}
    </Root>
  );
};
